const VAPID_PUBLIC_KEY = 'BCVJBIRlSi-vVogBa27aO0yfjxuXjRgdJhQeoUMmEJb0RkmXdCUzdIOAM9l99bXuOECajAA6fZwnlqr9rvkxBRE';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function requestNotificationPermission() {
  try {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      console.log('Push notifications not supported in this browser');
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('Notification permission denied');
      return null;
    }

    const registration = await navigator.serviceWorker.ready;

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
    });

    return subscription.toJSON();
  } catch (err) {
    console.log('Push subscription error (non-blocking):', err.message);
    return null;
  }
}

export function onForegroundMessage(callback) {
  try {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'PUSH_RECEIVED') {
          callback(event.data.payload);
        }
      });
    }
  } catch (e) {
    console.log('Foreground message listener not available');
  }
  return () => {};
}
